import React from 'react'
import colors from 'styles/colors'
import Icon from 'components/base-ui/Icon'
import Fonts from 'components/base-ui/Fonts'
import Button from 'components/base-ui/Button'
import { EmptyStateWarpper } from './styled'
import { useTranslation } from 'react-i18next'

const { baseGrey } = colors

interface CouponListEmptyProps {
  onClickRedeem: VoidFunction
}

const CouponListEmpty = ({ onClickRedeem }: CouponListEmptyProps) => {
  const { t } = useTranslation()
  return (
    <EmptyStateWarpper>
      <Icon name="coupon" size="48px" color={baseGrey} />
      <Fonts.SmallTitleBold style={{ color: baseGrey }}>{t('dineIn.coupon.emptyDescription')}</Fonts.SmallTitleBold>
      <Button md onClick={onClickRedeem}>
        {t('dineIn.coupon.redeemPointBtn')}
      </Button>
    </EmptyStateWarpper>
  )
}

export default CouponListEmpty
